import { Box } from "@radix-ui/themes";
import { dataProps } from "@/models/data.model";
import { TimeObj } from "@/hooks/useCountdown";
import { FC, JSX } from "react";

import SamsungScreen from "../../shared/SamsungScreen";
import CountdownHeader from "../CountdownHeader/CountdownHeader";
import CountdownClock from "../CountdownClock/CountdownClock";

const CountdownUI: FC<
  dataProps & {
    timeObj: TimeObj;
    title: "NEXT CHALLENGE IN" | "CHALLENGE ENDS IN";
  }
> = ({ timeObj, title }): JSX.Element => {
  return (
    <SamsungScreen>
      <CountdownHeader />

      <Box className="sr-countdown-body" flexGrow="1">
        <CountdownClock timeObj={timeObj} title={title} />
      </Box>
    </SamsungScreen>
  );
};

export default CountdownUI;
